<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >比赛管理</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">比赛列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="small" type="primary" v-preventReClick  @click="addConsumptionClick">创建比赛</el-button>
        <el-table size="small" :data="matchDataList" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="name" label="比赛名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="比赛状态" >
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 0">未发布</span>
                    <span v-if="scope.row.status == 1">未开始</span>
                    <span v-if="scope.row.status == 2">报名中</span>
                    <span v-if="scope.row.status == 3">比赛中</span>
                    <span v-if="scope.row.status == 4">已结束</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="比赛范围" >
                <template slot-scope="scope">
                    {{scope.row.province}}-{{scope.row.city}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="personNum" label="报名人数" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="报名起止时间" >
                <template slot-scope="scope">
                    {{scope.row.starttime}} -- {{scope.row.endtime}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="matchtime" label="比赛开始时间" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="overtime" label="比赛结束时间" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.status == 0" type="text" v-preventReClick @click="matchPublishClick(scope.row)">发布</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="editConsumptionClick(scope.row)">编辑</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="delMatch(scope.row)">删除</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="stageClick(scope.row)">阶段</el-button>
                    <el-button size="mini" type="text" v-if="scope.row.status != 0" v-preventReClick @click="applicationClick(scope.row)">报名</el-button>
                    <el-button size="mini" type="text" v-if="scope.row.status != 0" v-preventReClick @click="adminScreenClick(scope.row)">大屏直播链接</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="matchCopyClick(scope.row)">复制</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column  prop="createdAt" label="提交时间" >
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column> -->
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 新增 -->
        <el-dialog :visible.sync="addCompetitionFlag" width="40%" >
            <el-form label-width="200px" :model="addCompetitionForm" :rules="rules" ref="addCompetitionForm">
                <el-form-item label="比赛名称" prop="name">
                    <el-input size="small" style="width:350px" v-model="addCompetitionForm.name" auto-complete="off" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="比赛名称title" prop="titleImg">
                    <el-upload
                        class="upload-demo"
                        :http-request="CompetitionTitle"
                        :file-list="addCompetitionForm.titleImg"
                        :on-exceed="onExceed"
                        :on-remove="CompetitionTitleRemove"
                        :limit="1"
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="比赛介绍" prop="content">
                    <quill-editor
                        ref="myQuillEditor"
                        :content="addCompetitionForm.content"
                        :options="editorOption"
                        @change="onEditorChange($event)"
                    />
                </el-form-item>
                <el-form-item label="是否在麻将机展示比赛" >
                    <el-select v-model="addCompetitionForm.machineShow" placeholder="请选择">
                        <el-option label="展示" :value="true"></el-option>
                        <el-option label="不展示" :value="false"></el-option>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="比赛范围" >
                    <el-select v-model="addCompetitionForm.status" placeholder="请选择">
                        <el-option label="全国" :value="1"></el-option>
                        <el-option label="省/市" :value="0"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item label="比赛范围" prop="addr">
                    <el-cascader
                        :options="MatchLocationListData"
                        :props="{
                            value:'label',
                            checkStrictly:true
                         }"
                        v-model="addCompetitionForm.addr"
                        clearable></el-cascader>
                        
                </el-form-item>

                <el-form-item label="选择比赛游戏" prop="gameId">
                    <el-select v-model="addCompetitionForm.gameId" :disabled="addCompetitionForm.id != undefined" @change="gamesSlChange" placeholder="请选择">
                        <el-option v-for="item in gamesList" :key="item.id" :label="item.gameName"  :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="报名起止时间" prop="starttime">
                    <el-date-picker
                        format="yyyy年MM月dd日 HH:mm:ss"
                        value-format="yyyy年MM月dd日 HH:mm:ss"
                        @change="daterangeChange"
                        v-model="addCompetitionForm.dateTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['08:00:00', '18:00:00']"
                        >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="限制报名人数" >
                    <el-select v-model="addCompetitionForm.limitPer" placeholder="请选择">
                        <el-option label="限制" :value="true"></el-option>
                        <el-option label="不限制" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="人数最多" prop="limitNum" v-if="addCompetitionForm.limitPer == true">
                    <el-input size="small" style="width:350px" v-model="addCompetitionForm.limitNum" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                
                <el-form-item label="麻将机展示图" prop="machinePics">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange1"
                        :file-list="addCompetitionForm.machinePics"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove1"
                        multiple
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="小程序和app展示图" prop="programPics">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange2"
                        :file-list="addCompetitionForm.programPics"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove2"
                        multiple
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="大屏网页展示图" prop="screenPics">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange3"
                        :file-list="addCompetitionForm.screenPics"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove3"
                        multiple
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="分享标题" prop="shareTitle">
                <el-input size="small" v-model="addCompetitionForm.shareTitle" auto-complete="off" placeholder="请输入分享标题"></el-input>
                </el-form-item>
                <el-form-item label="分享描述" prop="shareContent">
                <el-input size="small" v-model="addCompetitionForm.shareContent" auto-complete="off" placeholder="请输入分享描述"></el-input>
                </el-form-item>
                <el-form-item label="分享图片" prop="sharePic">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange4"
                        :file-list="addCompetitionForm.sharePic"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove4"
                        :limit="1"
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addCompetitionFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('addCompetitionForm')">保存</el-button>
            </div>
        </el-dialog>


        <!-- 阶段 -->
        <el-dialog :visible.sync="stageFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%" >
            <el-button size="small" type="primary" @click="addStageClick">添加阶段</el-button>
            <el-table size="small" :data="stageDataList" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="userPhone" label="所处阶段" >
                <template slot-scope="scope">
                    第{{scope.row.ordernum}}阶段
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="阶段名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="阶段状态" >

            </el-table-column>
            <el-table-column show-overflow-tooltip prop="machineNum" label="比赛设备台数" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="personNum" label="参赛人数" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="promotionNum" label="晋级人数" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="该阶段比赛起止日期" >
                <template slot-scope="scope">
                    {{scope.row.starttime}} -- {{scope.row.endtime}}
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" v-preventReClick @click="editStageClick(scope.row)">编辑信息</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="editRuleClick( scope.row)">编辑规则</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="sessionListClick(scope.row)">场次</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="liveManage( scope.row)">直播管理</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="bePromotedClick(scope.row)">晋级</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="stageTimeClick(scope.row)">时间测算</el-button>
                    <!-- <el-button size="mini" type="text" v-preventReClick @click="handleEdit( scope.row)">复制</el-button> -->
                    <el-button size="mini" type="text" v-if="(scope.$index + 1) == stageDataList.length" v-preventReClick @click="stageDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="stageFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 新增阶段 -->
        <el-dialog :visible.sync="addStageFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%" >
            <el-form label-width="180px" :model="addStageForm" :rules="rules" ref="addStageForm">
                <el-form-item label="阶段名称：" prop="name">
                    <el-input size="small" v-model="addStageForm.name" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="比赛开始日期：" v-if="addStageType == 1" prop="starttime">
                    <el-date-picker
                        v-model="addStageForm.starttime"
                        format="yyyy年MM月dd日 HH:mm:ss"
                        value-format="yyyy年MM月dd日 HH:mm:ss"
                        type="datetime"
                        placeholder="选择日期"
                        default-time="08:00:00">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="上阶段结束，第" v-if="addStageType == 2" prop="days">
                    <el-input placeholder="请输入天数" style="width:230px" v-model="addStageForm.days">
                        <template slot="append">天，开始</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addStageFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="StageSubmitForm('addStageForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 编辑阶段规则 -->
        <el-dialog :visible.sync="editRuleFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%" >
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="GameRulesClick()">游戏规则</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editCompetitionMethodClick()">比赛方式</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="siteListClick()">参赛设备</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editMatchingMethodClick()">匹配方式</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editBePromotedClick()">晋级方式</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="CompetitionRewardsClick()">设置比赛奖励</el-button>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editRuleFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 比赛方式 -->
        <el-dialog :visible.sync="editCompetitionMethodFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="70%" >
            <el-form label-width="150px" :model="editCompetitionMethodForm" :rules="rules" ref="editCompetitionMethodForm">
                <el-form-item label="比赛单位：" prop="gameUnit">
                    <el-radio-group v-model="editCompetitionMethodForm.gameUnit" @change="radioChange" disabled>
                        <el-radio  v-for="item in MethodData" :key="item.unit" :label="item.unit">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="比赛方式：" prop="type" v-if="editCompetitionMethodForm.gameUnit != ''">
                    <el-radio-group v-model="editCompetitionMethodForm.type">
                        <el-radio-button :label="1">固定{{gameUnitName}}数兜底时间</el-radio-button>
                        <el-radio-button :label="2">固定时间{{gameUnitName}}数不限</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="`比赛${gameUnitName}数:`" v-if="editCompetitionMethodForm.gameUnit != '' && editCompetitionMethodForm.type == 1" prop="timesNum">
                    <el-radio-group v-model="editCompetitionMethodForm.timesNum">
                        <el-radio-button v-for="item in gameUnitNumS" :key="item" :label="item">{{item}}{{gameUnitName}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="比赛局数：" v-if="CompetitionObj.matchGame.signNum == 1 && editCompetitionMethodForm.type == 1" prop="timesNum">
                    <el-radio-group v-model="editCompetitionMethodForm.timesNum">
                        <el-radio-button :label="1">1局</el-radio-button>
                        <el-radio-button :label="2">2局</el-radio-button>
                        <el-radio-button :label="3">3局</el-radio-button>
                        <el-radio-button :label="4">4局</el-radio-button>
                        <el-radio-button :label="5">5局</el-radio-button>
                        <el-radio-button :label="10">10局</el-radio-button>
                        <el-radio-button :label="20">20局</el-radio-button>
                        <el-radio-button :label="30">30局</el-radio-button>
                        <el-radio-button :label="40">40局</el-radio-button>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="比赛限时" prop="timeLong">
                    <el-radio-group v-model="editCompetitionMethodForm.timeLong">
                        <el-radio-button :label="1">1分钟</el-radio-button>
                        <el-radio-button :label="10">10分钟</el-radio-button>
                        <el-radio-button :label="20">20分钟</el-radio-button>
                        <el-radio-button :label="30">30分钟</el-radio-button>
                        <el-radio-button :label="40">40分钟</el-radio-button>
                        <el-radio-button :label="50">50分钟</el-radio-button>
                        <el-radio-button :label="60">60分钟</el-radio-button>
                        <el-radio-button :label="90">90分钟</el-radio-button>
                        <el-radio-button :label="120">120分钟</el-radio-button>
                        <el-radio-button v-if="CompetitionObj.matchGame.signNum == 2" :label="180">180分钟</el-radio-button>
                        <el-radio-button v-if="CompetitionObj.matchGame.signNum == 2" :label="240">240分钟</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="每场开始前多久设备自动进入比赛模式" prop="beforetime">
                    <el-radio-group v-model="editCompetitionMethodForm.beforetime">
                        <el-radio-button :label="1">1分钟</el-radio-button>
                        <el-radio-button :label="5">5分钟</el-radio-button>
                        <el-radio-button :label="10">10分钟</el-radio-button>
                        <el-radio-button :label="15">15分钟</el-radio-button>
                        <el-radio-button :label="20">20分钟</el-radio-button>
                        <el-radio-button :label="25">25分钟</el-radio-button>
                        <el-radio-button :label="30">30分钟</el-radio-button>
                        <el-radio-button :label="45">45分钟</el-radio-button>
                        <el-radio-button :label="60">60分钟</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editCompetitionMethodFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editCompetitionMethodSubmitForm('editCompetitionMethodForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 匹配方式 -->
        <el-dialog :visible.sync="editMatchingMethodFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-form label-width="180px" :model="editMatchingMethodForm" :rules="rules" ref="editMatchingMethodForm">
                <el-form-item label="比赛方式：" prop="type">
                    <el-radio-group v-model="editMatchingMethodForm.type">
                        <el-radio-button :label="1">线上匹配</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="匹配规则" >
                    <el-radio-group v-model="editMatchingMethodForm.ruleId" >
                        <el-radio-button :label="1">随机匹配</el-radio-button>
                        <el-radio-button v-if="stageDataForm.ordernum != 1" :label="2">瑞士移位</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="报名到达(游戏人数的倍数)" prop="personMulNum" v-if="stageDataForm.ordernum == 1" >
                    <el-select v-model="editMatchingMethodForm.personMulNum"  placeholder="请选择">
                        <el-option label="1" :value="1"></el-option>
                        <el-option label="2" :value="2"></el-option>
                        <el-option label="3" :value="3"></el-option>
                        <el-option label="4" :value="4"></el-option>
                        <el-option label="5" :value="5"></el-option>
                        <el-option label="6" :value="6"></el-option>
                        <el-option label="7" :value="7"></el-option>
                        <el-option label="8" :value="8"></el-option>
                        <el-option label="9" :value="9"></el-option>
                        <el-option label="10" :value="10"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editMatchingMethodFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick class="title" @click="editMatchingMethodSubmit('editMatchingMethodForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 晋级方式 -->
        <el-dialog :visible.sync="editBePromotedFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-form label-width="180px" :model="editBePromotedForm" :rules="rules" ref="editBePromotedForm">
                <el-form-item label="排定方式：" prop="type">
                    <el-radio-group v-model="editBePromotedForm.type" @change="typeRadio">
                        <el-radio-button :label="1">整体排名</el-radio-button>
                        <el-radio-button :label="2">单桌排名</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="晋级方式：" prop="orderNum" v-if="editBePromotedForm.type == 1">
                    <el-radio-group v-model="editBePromotedForm.isProportion">
                        <el-radio-button :label="true">按比例</el-radio-button>
                        <el-radio-button :label="false">按{{CompetitionObj.matchGame.signNum == 2?'组':'人'}}数</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="晋级比例：" v-if="editBePromotedForm.isProportion == true" prop="promotedNum">
                    <el-input size="small" v-model="editBePromotedForm.promotedNum" style="width:230px" auto-complete="off" placeholder="请输入">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item :label="`晋级${CompetitionObj.matchGame.signNum == 2?'组':'人'}数：`"  v-if="editBePromotedForm.type == 1 && editBePromotedForm.isProportion == false "  prop="promotedNum">
                    <el-input size="small" v-model="editBePromotedForm.promotedNum" style="width:230px" auto-complete="off" placeholder="请输入">
                        <template slot="append">{{CompetitionObj.matchGame.signNum == 2?'组':'人'}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="每座晋级人数："  v-if="editBePromotedForm.type == 2 && CompetitionObj.matchGame.signNum == 1"  prop="promotedNum">
                    <el-input size="small" v-model="editBePromotedForm.promotedNum" style="width:230px" auto-complete="off" placeholder="请输入">
                        <template slot="append">人</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editBePromotedFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editBePromotedSubmit('editBePromotedForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 奖励 -->
        <el-dialog :visible.sync="CompetitionRewardsFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-button size="small" style="margin:20px 0" type="primary" @click="addRewardClick(1)">添加排名奖励</el-button>
            <el-table size="small" :data="RankingRewardsData" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="userPhone" label="奖励名次" >
                    <template slot-scope="scope">
                        {{scope.row.lowRank}}-{{scope.row.upRank}}名
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="prizeName" label="奖品名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="prizePics" label="奖品图片" >
                    <template slot-scope="scope" align="center">
                        <el-image
                        style="width: 200px; height: 100px"
                        class="img_inner"
                        :src="scope.row.prizePics"
                        fit="fit"></el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="editRewards(scope.row)">编辑</el-button>
                        <el-button size="mini" type="text" v-if="(scope.$index + 1) == RankingRewardsData.length" v-preventReClick @click="RankingDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-button size="small" style="margin:20px 0" type="primary" @click="addRewardClick(0)">添加阳光普照奖励</el-button>
            <el-table size="small" :data="PromotionRewardData" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="prizeName" label="奖品名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="prizePics" label="奖品图片" >
                    <template slot-scope="scope" align="center">
                        <el-image
                        style="width: 200px; height: 100px"
                        class="img_inner"
                        :src="scope.row.prizePics"
                        fit="fit"></el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="editRewards(scope.row)">编辑</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="RankingDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="CompetitionRewardsFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 添加-编辑奖励 -->
        <el-dialog :visible.sync="AddRewardFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-form label-width="180px" :model="AddRewardForm" :rules="rules" ref="AddRewardForm">
                <el-form-item label="奖励名次" v-if="AddRewardForm.type == 1" prop="upRank">
                    <el-input placeholder="请输入" disabled style="width:150px" v-model="AddRewardForm.lowRank">
                        <template slot="append">名</template>
                    </el-input>
                    至
                    <el-input placeholder="请输入" :disabled="editRewardsFlag" style="width:150px" v-model="AddRewardForm.upRank">
                        <template slot="append">名</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="奖品名称：" prop="prizeName">
                    <el-input size="small" v-model="AddRewardForm.prizeName" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="奖励图片：" prop="prizePics">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange5"
                        :file-list="AddRewardForm.prizePics"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove5"
                        :limit="1"
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="AddRewardFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="AddRewardSubmit('AddRewardForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 比赛规则 -->
        <el-dialog :visible.sync="GameRulesFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%" >
            <GameRules 
            v-if="GameRulesFlag" 
            ref="GameRulesRef" 
            :stageId="stageId"
            :matchId="CompetitionObj.id"
            @cancel="GameRulesCancel"
            @submitFun="GameRulesSubmitFun"
            :gameId="CompetitionObj.matchGame.id"
            :matchGame="CompetitionObj.matchGame"
            ></GameRules>
            <!-- <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="GameRulesFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="GameRulesSubmit('editForm')">保存</el-button>
            </div> -->
        </el-dialog>

        <!-- 场地管理 -->
        <el-dialog :visible.sync="SiteManagementFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-button size="small" style="margin:20px 0" type="primary" @click="addSizeClick()">添加场地</el-button>
            <el-table size="small" :data="SiteManagementData" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="name" label="场地名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="matchNum" label="设备台数" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="siteAddr" label="地址" ></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="editSiteClick(scope.row)">编辑</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="siteDelClick(scope.row)">删除</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="deviceEditClick(scope.row)">设备管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-for="item in siteTimeList" :key="item.type">
                <div style="margin:20px;display:flex">
                    <div style="margin-right:40px"><h3>周{{item.type}}</h3></div>
                    <div>
                        <el-button size="small" @click="addTimeClick(item.type)">添加时间段</el-button>
                            <div v-for="items in item.timeList" :key="items.id">
                            <div style="font-size:16px;line-height:40px">{{items.noticetime}} -- {{items.endtime}}  <span style="color:red" @click="delTimeClick(items)">删除</span></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="SiteManagementFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 添加时间段 -->
        <el-dialog :visible.sync="addTimeFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="30%">
            <el-form :inline="true" :model="m2achineReplaceForm" :rules="rules" ref="m2achineReplaceForm">
                <el-form-item label="比赛时间" >
                    游戏时长：{{matchwayDetailForm.timeLong}}分钟 ， 提前{{matchwayDetailForm.beforetime}}分钟进入比赛模式
                </el-form-item>
                <el-form-item label="选择时间" >
                    <el-time-picker
                        @change="noticetimeChange"
                        value-format="HH:mm:SS"
                        v-model="matchwayDetailForm.noticetime"
                        placeholder="任意时间点">
                    </el-time-picker>
                </el-form-item>
                <el-form-item v-if="matchwayDetailForm.endtime != ''" >
                    该时段比赛时间：{{matchwayDetailForm.noticetime}} - {{matchwayDetailForm.endtime}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addTimeFlag = false">关闭</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addTimeSubmit('m2achineReplaceForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 添加场地 -->
        <el-dialog :visible.sync="addSiteFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-form label-width="180px" :model="addSiteForm" :rules="rules" ref="addSiteForm">
                <el-form-item label="场地名称：" prop="name">
                    <el-input size="small" v-model="addSiteForm.name" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="siteAddr">
                    <el-input size="small" v-model="addSiteForm.siteAddr" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="场地图片（可传多张）：" prop="pics">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange6"
                        :file-list="addSiteForm.pics"
                        :on-exceed="onExceed"
                        :on-remove="HandleRemove6"
                        :limit="9"
                        multiple
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addSiteFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addSiteSubmit('addSiteForm')">保存</el-button>
            </div>
        </el-dialog>
        

        <!-- 设备管理 -->
        <el-dialog :visible.sync="deviceFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-form :inline="true" :model="deviceForm" :rules="rules" ref="deviceForm">
                <el-form-item label="设备sn码：" prop="machineId">
                    <el-select v-model="deviceForm.machineId" filterable placeholder="请选择">
                        <el-option
                        v-for="item in MachineList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称：" prop="name">
                    <el-input size="small" v-model="deviceForm.name" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="排序：" prop="orderCode">
                    <el-input size="small" v-model="deviceForm.orderCode" style="width:230px" placeholder="请输入序号"></el-input>
                </el-form-item>
                
                <el-form-item >
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="deviceFormSubmit('deviceForm')">添加</el-button>
                </el-form-item>
            </el-form>
            <el-table size="small" :data="m2achineDataList" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="name" label="设备名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="machineId" label="设备sn码" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="location" label="当前位置" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="isonline" label="当前开机状态" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="businessUser" label="所属商户端账号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="所属商户端手机号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="orderCode" label="序号" ></el-table-column>
                
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="editM2achineClick(scope.row)">编辑</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="m2achineReplaceClick(scope.row)">替换</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="m2achineDelClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="deviceFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 修改设备信息 -->
        <el-dialog :visible.sync="editM2achineReplaceFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="30%">
            <el-form :inline="true" :model="editM2achineReplaceForm" :rules="rules" ref="editM2achineReplaceForm">
                <el-form-item label="设备名称：" prop="name">
                    <el-input size="small" v-model="editM2achineReplaceForm.name" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="排序：" prop="orderCode">
                    <el-input size="small" v-model="editM2achineReplaceForm.orderCode" style="width:230px" placeholder="请输入序号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editM2achineReplaceFlag = false">关闭</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="editM2achineReplaceSubmit('editM2achineReplaceForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 设备替换 -->
        <el-dialog :visible.sync="m2achineReplaceFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="30%">
            <el-form :inline="true" :model="m2achineReplaceForm" :rules="rules" ref="m2achineReplaceForm">
                <el-form-item label="设备sn码：" prop="machineId">
                    <el-select v-model="m2achineReplaceForm.machineId" filterable placeholder="请选择">
                        <el-option
                        v-for="item in MachineList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="m2achineReplaceFlag = false">关闭</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="m2achineReplaceSubmit('m2achineReplaceForm')">保存</el-button>
            </div>
        </el-dialog>
       
        <!-- 报名 -->
        <el-dialog :visible.sync="applicationFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="ManualRegistrationClick()">添加报名用户</el-button>
            <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="ManualMatchingClick()">手动匹配</el-button>
            <el-form :inline="true" :model="applicationForm" :rules="rules" ref="applicationForm">
                <el-form-item label="用户昵称：">
                    <el-input size="small" v-model="applicationForm.nickname" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="用户手机号：" >
                    <el-input size="small" v-model="applicationForm.phone" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="匹配状态：" >
                    <el-select v-model="applicationForm.status" filterable placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未匹配" :value="0"></el-option>
                        <el-option label="已匹配" :value="1"></el-option>
                        <el-option label="匹配失败" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="getApplicationList()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table size="small" :data="applicationData" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="signNum" label="选手号码" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="userid" label="用户id" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户昵称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="用户手机号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="createtime" label="报名时间" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="sessionStatus" label="匹配状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.sessionStatus == 0">未匹配</span>
                        <span v-if="scope.row.sessionStatus == 1">已匹配</span>
                        <span v-if="scope.row.sessionStatus == 2">匹配失败</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="CancelRegistration(scope.row)">取消报名</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="applicationPage" @callFather="applicationCallFather"></Pagination>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="applicationFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 手动匹配 -->
        <el-dialog :visible.sync="ManualMatchingFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-form :model="ManualMatchingForm" label-width="180px" :rules="rules" ref="ManualMatchingForm">
                <el-form-item label="选手：" >
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addPlayerClick()">添加选手</el-button>
                    <el-table size="small" :data="ManualMatchingForm.userids" max-height="400px"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="signNum" label="选手号码" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="nickname" label="用户id" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="nickname" label="用户昵称" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="phone" label="用户手机号" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="createtime" label="报名时间" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="integral" label="匹配状态" >
                            <template >
                                未匹配
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" type="text" v-preventReClick @click="ManualMatchingFormDel(scope.$index , scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="请设备选择：" prop="machineId">
                    <el-select v-model="ManualMatchingForm.machineId" placeholder="请选择">
                        <el-option v-for="item in machineDataList" :key="item.id" :label="item.machineId" :value="item.machineId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择场次开始时间" prop="starttime">
                    <el-date-picker
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="ManualTimeChange"
                    v-model="ManualMatchingForm.starttime"
                    type="datetime"
                    placeholder="选择日期时间">
                    </el-date-picker>
                    <div v-if="ManualMatchingForm.endtime">{{ManualMatchingForm.noticetime}} -- {{ManualMatchingForm.endtime}}</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="ManualMatchingFlag = false">关闭</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="ManualMatchingSubmit('ManualMatchingForm')">确认匹配</el-button>
            </div>
        </el-dialog>

        <!-- 添加选手 -->
        <el-dialog :visible.sync="addPlayerFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-table size="small" :data="addPlayerData" max-height="400px"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="signNum" label="选手号码" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户id" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户昵称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="用户手机号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="seatNo" label="报名时间" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="匹配状态" >
                    <template >
                        未匹配
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="selectSubmit(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addPlayerFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 手动报名 -->
        <el-dialog :visible.sync="ManualRegistrationFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="30%">
            <el-form :model="ManualRegistrationForm" label-width="180px" :rules="rules" ref="applicationForm">
                <el-form-item label="用户手机号：" >
                    <el-input size="small" v-model="ManualRegistrationForm.phone" style="width:230px" placeholder="请输入手机号"></el-input>
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="getUserDetails(1)">查询</el-button>
                </el-form-item>
                <el-form-item label="用户昵称：">
                    <el-input size="small" v-model="ManualRegistrationForm.nickname" style="width:230px" placeholder="请输入昵称"></el-input>
                </el-form-item>
                <el-form-item label="队友用户手机号：" v-if="CompetitionObj.matchGame.signNum == 2" >
                    <el-input size="small" v-model="ManualRegistrationForm.phone2" style="width:230px" placeholder="请输入手机号"></el-input>
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="getUserDetails(2)">查询</el-button>
                </el-form-item>
                <el-form-item label="队友用户昵称：" v-if="CompetitionObj.matchGame.signNum == 2">
                    <el-input size="small" v-model="ManualRegistrationForm.nickname2" style="width:230px" placeholder="请输入昵称"></el-input>
                </el-form-item>
                <el-form-item label="匹配方式" >
                    <el-radio-group v-model="ManualRegistrationForm.usersType" >
                        <el-radio-button :label="1">手动匹配</el-radio-button>
                        <el-radio-button :label="0">自动匹配</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="ManualRegistrationFlag = false">关闭</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="ManualRegistrationSubmit()">确认报名</el-button>
            </div>
        </el-dialog>

        <!-- 场次列表 -->
        <el-dialog :visible.sync="sessionListFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-form :inline="true" :model="sessionListForm" :rules="rules" ref="applicationForm">
                <el-form-item label="用户昵称：">
                    <el-input size="small" v-model="sessionListForm.nickname" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="用户手机号：" >
                    <el-input size="small" v-model="sessionListForm.phone" style="width:230px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="场地名称：" >
                    <el-select v-model="sessionListForm.siteName" filterable placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item of SiteManagementData" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称：" >
                    <el-select v-model="sessionListForm.machineName" filterable placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item of getM2achineListData" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备sn码：" >
                    <el-select v-model="sessionListForm.machineId" filterable placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item of getM2achineListData" :key="item.id" :label="item.machineId" :value="item.machineId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="场次状态：" >
                    <el-select v-model="sessionListForm.status" filterable placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未匹配" :value="0"></el-option>
                        <el-option label="已匹配" :value="1"></el-option>
                        <el-option label="匹配失败" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="getSessionList()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table size="small" :data="sessionListData" max-height="600"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="id" label="场次id" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="machineId" label="比赛时间" >
                    <template slot-scope="scope">
                        {{scope.row.starttime}} - {{scope.row.endtime}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="siteName" label="场地名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="machineName" label="设备名称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="machineId" label="设备sn码" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="场次状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">未开始</span>
                        <span v-if="scope.row.status == 1">比赛中</span>
                        <span v-if="scope.row.status == 2">已结束</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="personNum" label="比赛人数" ></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="PlayersSituationClick(scope.row)">选手战况</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="sessionListFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 选手战况 -->
        <el-dialog :visible.sync="PlayersSituationFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <div>
                <div style="font-size:20px;line-height:60px">
                    <span v-if="PlayersSituationForm.status != 2">
                        <span>比赛局数：<span >{{PlayersSituationForm.simpleWay.gameNum}}局</span></span>
                        <span style="color:red" v-if="PlayersSituationForm.status == 1">当前正在进行：{{PlayersSituationForm.currentGameNum + 1}}局</span>
                    </span>
                    <span v-if="PlayersSituationForm.status == 2">实际比赛局数：<span >{{PlayersSituationForm.currentGameNum}}局</span></span>
                </div>
                <div style="font-size:20px;line-height:60px">
                    <span v-if="PlayersSituationForm.status != 2" style="display:flex">
                        <span >比赛限时：{{PlayersSituationForm.simpleWay.gameTime}}分钟</span>
                        <span style="display:flex;margin-left:5px;color:red" v-if="PlayersSituationForm.status == 1"> 还剩：<MinuteCountdown v-if="PlayersSituationFlag" :time="PlayersSituationForm.time"></MinuteCountdown>分钟</span>
                    </span>
                    <span v-if="PlayersSituationForm.status == 2">实际比赛时间：<span >{{PlayersSituationForm.time}}分钟</span></span>
                </div>
            </div>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="sessionHandlerClick()">手动结束</el-button>
            <el-table size="small" :data="PlayersSituationForm.users" max-height="400px"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="signNum" label="选手号码" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户头像" >
                    <template slot-scope="scope">
                        <img :src="scope.row.avatar" style="width:50px;height:50px;border-radius:50%"/>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户昵称" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="用户手机号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="seatNo" label="手屏序号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="积分" ></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="PlayersSituationFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 直播管理 -->
        <el-dialog :visible.sync="liveManageFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="40%">
            <el-form label-width="250px" :model="liveManageForm" :rules="rules" ref="liveManageForm">
                <el-form-item label="手牌默认状态：" prop="type">
                    <el-radio-group v-model="liveManageForm.type">
                        <el-radio-button :label="1">全不公开</el-radio-button>
                        <el-radio-button :label="2">全公开</el-radio-button>
                        <el-radio-button :label="3">只有主视角公开</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否允许用户切换所有用户手屏状态：" v-if="liveManageForm.type != 1">
                    <el-radio-group v-model="liveManageForm.changeScreen" >
                        <el-radio-button :label="false">不允许</el-radio-button>
                        <el-radio-button :label="true">允许</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否允许用户切换主视角：" >
                    <el-radio-group v-model="liveManageForm.changeMainView" >
                        <el-radio-button :label="false">不允许</el-radio-button>
                        <el-radio-button :label="true">允许</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="liveManageFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick class="title" @click="liveManageSubmit('liveManageForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 晋级列表 -->
        <el-dialog :visible.sync="bePromotedListFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="60%">
            <el-table size="small" :data="bePromotedListData.promotionList" max-height="400px"  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="signNum" label="名次" >
                    <template slot-scope="scope">
                        <span v-if="bePromotedListData.type == 1 && CompetitionObj.matchGame.signNum == 2">{{rankingFun(scope.$index + 1)}}</span>
                        <span v-if="bePromotedListData.type == 1 && CompetitionObj.matchGame.signNum == 1">{{scope.$index + 1}}</span>
                        <span v-if="bePromotedListData.type == 2">--</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="signNum" label="选手号码" >
                    <template slot-scope="scope">{{scope.row.promotionUser.signNum}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="nickname" label="用户昵称" >
                    <template slot-scope="scope">{{scope.row.promotionUser.nickname}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="用户手机号" >
                    <template slot-scope="scope">{{scope.row.promotionUser.phone}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="本阶段积分" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="createtime" label="本阶段对局局数" >
                    <template slot-scope="scope">{{scope.row.simpleSession.currentGameNum}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="createtime" label="本阶段对局时长" >
                    <template slot-scope="scope">{{scope.row.simpleSession.timeStr}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="createtime" label="晋级状态" >
                    <template slot-scope="scope">{{scope.row.isPromoted ==true?'已晋级':'未晋级'}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="createtime" label="收货信息" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.addr != null">{{scope.row.addr.province}}{{scope.row.addr.city}}{{scope.row.addr.district}}{{scope.row.addr.addrDetail}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-if="scope.row.isPromoted" v-preventReClick @click="seeAwardsClick(scope.row , scope.$index)">查看获奖</el-button>
                        <el-button size="mini" type="text" v-if="scope.row.isPromoted" v-preventReClick @click="editAddressClick(scope.row)">编辑收货地址</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <Pagination v-bind:child-msg="applicationPage" @callFather="applicationCallFather"></Pagination> -->
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="bePromotedListFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看奖励 -->
        <el-dialog :visible.sync="seeAwardsFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="30%">
            <div style="display:flex;align-items: center;margin-top:10px" v-for="item in seeAwardsData" :key="item.id">
                <img :src="item.prizePics" style="width:100px;height:100px;border-radius:8px"/>
                <span style="margin-left:20px">{{item.prizeName}}</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seeAwardsFlag = false">关闭</el-button>
            </div>
        </el-dialog>


        <!-- 编辑地址 -->
        <el-dialog :visible.sync="editAddressFlag" width="40%" @click="closeDialog">
            <el-form label-width="200px" :model="editAddressForm" :rules="rules" ref="editAddressForm">
                <el-form-item label="收货人姓名：" prop="name">
                    <el-input size="small" v-model="editAddressForm.name" style="width:230px" auto-complete="off" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="收货人手机号：" prop="phone">
                    <el-input size="small" v-model="editAddressForm.phone" style="width:230px" auto-complete="off" placeholder="请输入收货人手机号"></el-input>
                </el-form-item>
                <el-form-item label="所在地区：" prop="receiverValue">
                    <el-cascader
                        v-model="editAddressForm.receiverValue"
                        :options="proData"
                        :props="{
                            value:'label'
                        }"
                        @change="handleChange"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="addrDetail">
                    <el-input size="small" v-model="editAddressForm.addrDetail" style="width:230px" auto-complete="off" placeholder="请输入详细地址"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editAddressFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="editAddressSubmit('editAddressForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 大屏链接-->
        <el-dialog :visible.sync="adminScreenDetailFlag" :close-on-click-modal='false' :close-on-press-escape="false" width="45%">
            <el-form label-width="200px" :model="adminScreenDetailForm" :rules="rules" ref="editAddressForm">
                <el-form-item label="大屏直播地址:">
                    {{adminScreenDetailForm.url}}?id={{adminScreenDetailForm.id}}
                </el-form-item>
                <el-form-item label="添加手机号白名单:">
                    <el-input
                        type="textarea"
                        placeholder="请输入"
                        v-model="adminScreenDetailForm.phones"
                        show-word-limit
                        >
                        </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="adminScreenDetailFlag = false">关闭</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="adminScreenDetailSubmit()">保存</el-button>
            </div>
        </el-dialog>

        <!-- 测算工具 -->
        <el-dialog :visible.sync="stageTimeFlag" title="测算小工具" :close-on-click-modal='false' :close-on-press-escape="false" width="45%">
            <el-form label-width="200px" :model="stageTimeForm" :rules="rules" ref="stageTimeForm">
                <el-form-item label="参赛人数:">
                    <el-input placeholder="请输入内容" style="width:300px" v-model="stageTimeForm.stageTimePersonNum">
                        <template slot="append">人</template>
                    </el-input>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="stageTimeSubmit('stageTimeForm')">计算耗时</el-button>
                </el-form-item>
                <el-form-item label="">
                    本阶段比赛时间预估{{stageTimeForm.days}}天
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 复制比赛 -->
        <el-dialog :visible.sync="matchCopyFlag" title="复制比赛" :close-on-click-modal='false' :close-on-press-escape="false" width="45%">
            <el-form label-width="200px" :model="matchCopyForm" :rules="rules" ref="matchCopyForm">
                <el-form-item label="报名起止时间" prop="signEndDate">
                        <el-date-picker
                            format="yyyy年MM月dd日 HH:mm:ss"
                            value-format="yyyy年MM月dd日 HH:mm:ss"
                            @change="matchCopyFormTimeChange"
                            v-model="matchCopyForm.dateTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['08:00:00', '18:00:00']"
                            >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="比赛开始日期：" prop="firstStageStartDate">
                        <el-date-picker
                            v-model="matchCopyForm.firstStageStartDate"
                            format="yyyy年MM月dd日 HH:mm:ss"
                            value-format="yyyy年MM月dd日 HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                            default-time="08:00:00">
                        </el-date-picker>
                    </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="matchCopyFlag = false">关闭</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="matchCopySubmit('matchCopyForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-upload
            v-show="false"
            class="avatar-uploader"
            :data='fileUpload'
            :show-file-list="false"
            accept=".jpg , .png ,"
            :http-request="onUploadHandler"
            >
        </el-upload>
    </div>
</template>
<script>
import { regionData  } from 'element-china-area-data'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Pagination from '../../components/Pagination'
import GameRules from '../../components/competition/GameRules'
import MinuteCountdown from '../../components/competition/MinuteCountdown'
import { CompetitionMethodData, CompetitionMethodNum } from '../../utils/CompetitionMethod'
import { CompareTime , remainder  , formatTime} from '../../utils/util'
import { matchAdd , matchGames , matchList , matchDel , matchPublish , 
    stageList , stageAdd , stageDel , stageUpdate , matchwayDetail , matchwaySave,
    ruleAdd , ruleDetail , mateDetail , mateAdd , promotionDetail , promotionSave ,
    rewardSave , rewardList , rewardDel , siteList , siteSave , siteDel ,loadMachineList ,m2achineList,
    m2achineAdd , m2achineDel , m2achineReplace , timeList , timeAdd , timeDel , matchuserList , usersWithPhone ,
    matchuserAdd , sessionList , matchuserDel , getM2achineList , matchUpdate , sessionResult , promotionReward ,
    promotionList , sessionMate , sessionEndtime , matchMachine , matchaddrDetail , matchaddrSave  ,matchLocationList,
    matchliveAdd , adminScreenUpdate , adminScreenDetail  , matchScreenLogin , stageTime , sessionHandler , matchCopy,
    matchliveRule , m2achineUpdate
} from '../../api/competition'
export default {
    components:{
        Pagination,
        quillEditor,
        GameRules,
        MinuteCountdown
    },
    data(){
        return{
            editM2achineReplaceForm:{},
            editM2achineReplaceFlag:false,
            gameUnitName:'',//单位标题
            gameUnitNumS:[],//选择单位
            MethodData:[],//比赛游戏选择单位
            matchCopyFlag:false,
            matchCopyForm:{
                signEndDate:'',
                signStartDate:'',
                firstStageStartDate:'',
                matchId:'',
                dateTime:[]
            },
            stageTimeForm:{
                stageTimePersonNum:'',
            },
            stageTimeFlag:false,
            adminScreenDetailFlag:false,
            adminScreenDetailForm:{},
            seeAwardsFlag:false,
            seeAwardsData:[],
            MatchLocationListData:[],
            proData:regionData,
            editAddressFlag:false,
            editAddressForm:{},
            addPlayerFlag:false,
            addPlayerData:[],
            machineDataList:[],
            ManualMatchingFlag:false,
            ManualMatchingForm:{

            },
            PlayersSituationFlag:false,
            PlayersSituationForm:{
                simpleWay:{}
            },
            bePromotedListFlag:false,
            bePromotedListData:{},
            liveManageForm:{
                
            },
            liveManageFlag:false,
            getM2achineListData:[],
            sessionListForm:{
                nickName:'',
                phone:'',
                siteId:'',
                siteName:'',
                machineName:'',
                machineId:'',
            },
            sessionListData:[],
            sessionListFlag:false,
            ManualRegistrationFlag:false,
            ManualRegistrationForm:{
                nickname:'',
                phone:'',
                phoneFlag:false,
                nickname2:'',
                phone2:'',
                phoneFlag2:false,
            },
            applicationPage:{
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            applicationForm:{
                status:'',
                nickname:'',
                phone:'',
            },
            applicationFlag:false,
            applicationData:[],
            matchwayDetailForm:{},
            addTimeFlag:false,
            siteTimeList:[],
            m2achineReplaceForm:{},
            m2achineReplaceFlag:false,
            MachineList:[],
            deviceFlag:false,
            deviceForm:{},
            SiteDeviceData:[],
            m2achineDataList:[],
            addSiteForm:{},
            addSiteFlag:false,
            SiteManagementData:[],
            SiteManagementFlag:false,
            AddRewardForm:{
                lowRank:1,
                prizePics:[],
                prizeName:'',
                upRank:'',
            },
            editRewardsFlag:false,
            AddRewardFlag:false,
            CompetitionRewardsFlag:false,
            RankingRewardsData:[],
            PromotionRewardData:[],
            loading:false,
            GameRulesFlag:false,//比赛规则
            matchDataList:[],//比赛列表
            gamesList:[],//游戏列表
            city:[],
            editBePromotedFlag:false,
            editBePromotedForm:{
                type:1,
                isProportion:true
            },
            editMatchingMethodFlag:false,
            editMatchingMethodForm:{
                type:1,
                ruleId:1,
                ruleName:'',
                personMulNum:''
            },
            editCompetitionMethodForm:{
                
            },
            editCompetitionMethodFlag:false,
            editRuleFlag:false,
            addStageForm:{
                name:'',
                starttime:'',
                days:''
            },//阶段编辑信息
            addStageType:1,
            addStageFlag:false,
            addCompetitionFlag:false,
            addCompetitionForm:{
                name:"",
                content:"",
                machineShow:true,
                limitPer:true,
                limitNum:'',
                dateTime:[],
                starttime:"",
                endtime:"",
                shareTitle:"",
                shareContent:"",
                province:"",
                city:'',
                gameId:'',
                gameName:'',
                machinePics:[],
                screenPics:[],
                programPics:[],
                sharePic:[],
            },//比赛编辑信息
            listData:[{}],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            editorOption: {
                modules: {
                toolbar: {
                    container: [
                    ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                    [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                    [{ indent: '-1' }, { indent: '+1' }], // 缩进
                    [{ direction: 'rtl' }], // 文本方向
                    // [{ font: ['songti'] }], // 字体种类
                    ['clean'], // 清除文本格式
                    ['image'] // 链接、图片、视频
                    ],
                    handlers: {
                        'image': function (value) {
                            if (value) { // value === true
                                document.querySelector('.avatar-uploader input').click()
                            } else {
                                this.quill.format('image', false)
                            }
                        }
                    }
                }
                },
                placeholder: '请输入正文'
            },
            stageFlag:false,
            cityOptions: [],
            rules: {
                name : [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                content : [
                    { required: true, message: '请输入比赛介绍', trigger: 'blur' }
                ],
                gameId : [
                    { required: true, message: '请选择比赛游戏', trigger: 'blur' }
                ],
                starttime : [
                    { required: true, message: '请选择时间', trigger: 'blur' }
                ],
                limitNum : [
                    { required: true, message: '请输入最多多少人', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                machinePics : [
                    { required: true, message: '请上传麻将机展示图', trigger: 'blur' }
                ],
                screenPics : [
                    { required: true, message: '请上传小程序和app展示图', trigger: 'blur' }
                ],
                sharePic : [
                    { required: true, message: '请上传请上传分享图片', trigger: 'blur' }
                ],
                programPics : [
                    { required: true, message: '请上传大屏展示图', trigger: 'blur' }
                ],
                shareTitle : [
                    { required: true, message: '请输入分享标题', trigger: 'blur' }
                ],
                shareContent : [
                    { required: true, message: '请输入分享内容', trigger: 'blur' }
                ],
                days: [
                    { required: true, message: '请输入天数', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                timesNum: [
                    { required: true, message: '请选择局数', trigger: 'blur' },
                ],
                timeLong: [
                    { required: true, message: '请选择比赛限时', trigger: 'blur' },
                ],
                beforetime: [
                    { required: true, message: '请选择比赛前多少分钟进入', trigger: 'blur' },
                ],
                personMulNum: [
                    { required: true, message: '请选择报名到达(游戏人数的倍数)', trigger: 'blur' },
                ],
                promotedNum: [
                    { required: true, message: '请输入晋级数', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                upRank: [
                    { required: true, message: '请输入名次', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                prizeName:[
                    { required: true, message: '请输入奖励名称', trigger: 'blur' },
                ],
                prizePics:[
                    { required: true, message: '请上传奖励图片', trigger: 'blur' },
                ],
                siteAddr:[
                    { required: true, message: '请输入地址', trigger: 'blur' },
                ],
                pics:[
                    { required: true, message: '请上传图片', trigger: 'blur' },
                ],
                machineId:[
                    { required: true, message: '请选择设备', trigger: 'blur' },
                ],
                noticetime:[
                    { required: true, message: '请选择时间', trigger: 'blur' },
                ],
                addrDetail:[
                    { required: true, message: '请输入详细地址', trigger: 'blur' },
                ],
                receiverValue:[
                    { required: true, message: '请选择省市区', trigger: 'blur' },
                ],
                phone:[
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ }
                ],
                addr:[
                    { required: true, message: '请输入选择范围', trigger: 'blur' },
                ],
                stageTimePersonNum:[
                    { required: true, message: '请输入人数', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                signEndDate:[
                    { required: true, message: '请选择报名起止时间', trigger: 'blur' },
                ],
                firstStageStartDate:[
                    { required: true, message: '请选择比赛开始时间', trigger: 'blur' },
                ],
                titleImg:[
                    { required: true, message: '请上传比赛名称title', trigger: 'blur' },
                ],
                orderCode:[
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
            },
            competitionId:'',//比赛id
            stageDataList:[],//阶段列表
            CompetitionObj:{
                matchGame:{}
            },//比赛信息
            stageDataForm:{},//阶段信息
            pnum:0,//游戏人数
            siteDataForm:{},//场地信息
            stageId:'',//阶段id
            sessionId:'',//场次id
        }
    },
    created(){
        this.getMatchList()
        this.matchGamesList()
        this.getLoadMachineList()
        this.getMatchLocationList()
    },
    methods:{
        radioChange(e){
            let data = CompetitionMethodNum(e)
            this.gameUnitName = data.name
            this.gameUnitNumS = data.numS
        },
        // 复制 比赛提交
        matchCopySubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.matchCopyForm)
                    let time1 = new Date(formatTime(this.matchCopyForm.signStartDate)).getTime()
                    let time2 = new Date(formatTime(this.matchCopyForm.firstStageStartDate)).getTime()
                    if(time1 > time2){
                        this.$message.error('比赛开始时间不能在报名开始时间之前')
                        return
                    }
                    matchCopy(this.matchCopyForm).then(res=>{
                       if(!res.success){
                            this.$message.error(res.message)
                       }else{
                            this.$message.success('复制成功')
                            this.matchCopyFlag = false
                            this.getMatchList()
                       }
                    })
                } else {
                    return false
                }
            })
        },
        // 点击复制比赛
        matchCopyClick(row){
            this.competitionId = row.id
            this.matchCopyForm = {
                dateTime:[],
                signEndDate:'',
                signStartDate:'',
                firstStageStartDate:'',
                matchId:row.id
            }
            this.matchCopyFlag = true
        },
        matchCopyFormTimeChange(e){
            console.log(e)
            this.matchCopyForm.signStartDate = e[0]
            this.matchCopyForm.signEndDate = e[1]
        },
        stageTimeSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.liveManageForm)
                    stageTime({
                        stageId:this.stageId,
                        personNum:Number(this.stageTimeForm.stageTimePersonNum)
                    }).then(res=>{
                        this.stageTimeForm.days = res.data.days
                    })
                } else {
                    return false
                }
            })
        },
        stageTimeClick(row){
            this.stageId = row.id
            this.stageTimeForm = {
                days:'',
                stageTimePersonNum:''
            }
            this.stageTimeFlag = true
        },
        adminScreenDetailSubmit(){
            if(this.adminScreenDetailForm.phones == ''){
                this.$message.error('请添加手机号白名单')
            }else{
                adminScreenUpdate({
                    id:this.competitionId,
                    phones:this.adminScreenDetailForm.phones
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('修改成功')
                        this.adminScreenDetailFlag = false
                    }
                })
            }
        },
        // 获取大屏链接配置
        adminScreenClick(row){
            this.competitionId = row.id
            adminScreenDetail(row.id).then(res=>{
                this.adminScreenDetailFlag = true
                this.adminScreenDetailForm = res.data == null?{phones:''}:res.data
            })
        },
        // 设置直播配置
        liveManageSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.liveManageForm)
                    matchliveAdd(this.liveManageForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('设置成功')
                            this.liveManageFlag = false
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 获取奖励信息
        seeAwardsClick(row , index){
            // seeAwardsData
            promotionReward({
                num:this.bePromotedListData.type == 1?(index + 1):'',
                userid:row.userid,
                stageId:this.stageId
            }).then(res=>{
                this.seeAwardsFlag = true
                this.seeAwardsData = res.data
            })
            console.log(row)
        },
        // 获取机器地址
        getMatchLocationList(){
            matchLocationList().then(res=>{
                this.MatchLocationListData = res.data
            })
        },
        // 编辑收货地址提交
        editAddressSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.editAddressForm)
                    let data = this.editAddressForm
                    data.province = data.receiverValue[0]
                    data.city = data.receiverValue[1]
                    data.district = data.receiverValue[2]
                    matchaddrSave(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('保存成功')
                            this.bePromotedClick({id:this.stageId})
                            this.editAddressFlag = false
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 点击编辑地址
        editAddressClick(row){
            console.log(row)
            matchaddrDetail({
                stageId:this.stageId,
                userId:row.userid,
            }).then(res=>{
                if(res.data == null){
                    this.editAddressForm = {
                        receiverValue:[],
                        stageId:this.stageId,
                        matchId:this.competitionId,
                        userid:row.userid,
                        name:'',
                        phone:'',
                        addrDetail:'',
                    }
                    this.editAddressFlag = true
                }else {
                    res.data.receiverValue = [`${res.data.province}`,`${res.data.city}`,`${res.data.district}`]
                    this.editAddressForm = res.data
                    this.editAddressFlag = true
                }
            })
            
        },
        // 手动匹配删除以选择选手
        ManualMatchingFormDel(index , row){
            if(row.groupId == 0){
                this.ManualMatchingForm.userids.splice(index , 1)
            }else {
                let data = []
                this.ManualMatchingForm.userids.forEach((item)=>{
                    if(item.groupId != row.groupId){
                        data.push(item)
                    }
                })
                this.ManualMatchingForm.userids  = data
            }
        },
        // 选择选手
        selectSubmit(row){
            console.log(row)
            if(row.groupId == 0){
                if(this.ManualMatchingForm.userids.some(item => item.id === row.id)){
                    this.$message.error('该选手已添加')
                }else {
                    if(this.ManualMatchingForm.userids.length == 4){
                        this.$message.error('选手最多可添加4人')
                    }else{
                        this.ManualMatchingForm.userids.push(row)
                    }
                }
            }else {
                if(this.ManualMatchingForm.userids.some(item => item.id === row.id)){
                    this.$message.error('该选手已添加')
                }else {
                    if(this.ManualMatchingForm.userids.length == 4){
                        this.$message.error('选手最多可添加4人')
                    }else{
                        let data = []
                        this.addPlayerData.forEach((item)=>{
                            if(item.groupId == row.groupId){
                                data.push(item)
                            }
                        })
                        this.ManualMatchingForm.userids = this.ManualMatchingForm.userids.concat(data)
                    }
                }
            }
        },
        ManualMatchingSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    let data = JSON.parse(JSON.stringify(this.ManualMatchingForm))
                    let userArr = []
                    let DisruptionFlag = false
                    this.ManualMatchingForm.userids.forEach((item)=>{
                        console.log(item)
                        DisruptionFlag = item.groupId == 0?false:true
                        userArr.push(item.userid)
                    })
                    // 调换选手位置
                    if(DisruptionFlag == true && userArr.length == 4){
                        console.log(1321312313)
                        userArr.splice(1,1,...userArr.splice(2,1,userArr[1]))
                    }
                    data.userids = userArr
                    sessionMate(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else{
                            this.$message.success('匹配成功')
                            this.ManualMatchingFlag = false
                            this.getApplicationList()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        addPlayerClick(){
            matchuserList({
                page:1,
                pageSize:500,
                matchid:this.CompetitionObj.id,
                status:0,
                type:1
            }).then(res=>{
                this.addPlayerData = res.data.dataList
                this.addPlayerFlag = true
            })
        },
        // 获取场次时间段
        ManualTimeChange(e){
            console.log(e)
            
            sessionEndtime({
                matchid:this.CompetitionObj.id,
                time:this.ManualMatchingForm.starttime
            }).then(res=>{
                this.ManualMatchingForm.endtime = res.data.endtime
                this.ManualMatchingForm.stageId = res.data.stageId
                this.ManualMatchingForm.noticetime = res.data.starttime
            })
        },
        // 手动匹配点击
        ManualMatchingClick(){
            matchMachine(this.CompetitionObj.id).then(res=>{
                this.ManualMatchingForm = {
                    matchId:this.CompetitionObj.id,
                    machineId:'',
                    userids:[],
                    endtime:'',
                    starttime:'',
                }
                this.ManualMatchingFlag = true
                this.machineDataList = res.data
            })
        },
        // 排名序号处理
        rankingFun(index){
            console.log(index)
            return Math.floor(index/2) + index%2
        },
        // 点击晋级
        bePromotedClick(row){
            this.stageId = row.id
            promotionList({stageId:row.id}).then(res=>{
                this.bePromotedListFlag = true
                this.bePromotedListData = res.data
            })
            // for(let i=1;i<=5;i++){
            //     console.log()
            // }
        },
        // 直播管理
        liveManage(row){
            matchliveRule(row.id).then(res=>{
                this.stageId = row.id
                if(res.data == null){
                    this.liveManageForm = {
                        changeMainView:false,
                        changeScreen:false,
                        type:1,
                        stageId:row.id,
                        matchId:this.competitionId
                    }
                }else {
                    this.liveManageForm = res.data
                }
                
                this.liveManageFlag = true
            })
            
        },
        // 点击场次
        sessionListClick(row){
            this.sessionListForm = {
                nickName:'',
                phone:'',
                siteId:'',
                siteName:'',
                machineName:'',
                machineId:'',
                matchId:this.competitionId,
                stageId:row.id
            },
            this.stageId = row.id
            this.sessionListFlag = true
            this.getSessionList()
            this.getSiteMatchList()
        },
        getSiteMatchList(){
            getM2achineList(this.stageId).then(res=>{
                this.getM2achineListData = res.data
            })
            siteList(this.stageId).then(res=>{
                this.SiteManagementData = res.data
            })
        },
        // 选手战况
        PlayersSituationClick(row){
            this.sessionId = row.id
            sessionResult(row.id).then(res=>{
                if(res.data.status == 1){
                    res.data.time = remainder(new Date(),res.data.endtime)
                }else if(res.data.status == 2){
                    res.data.time = remainder(res.data.starttime , res.data.endtime)   
                }
                console.log(res.data)
                this.PlayersSituationForm = res.data
                this.PlayersSituationFlag = true
            })
        },
        sessionHandlerClick(){
            this.$confirm('是否手动结束?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                sessionHandler(this.sessionId).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.PlayersSituationClick({id:this.sessionId})
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        // 场次列表
        getSessionList(){
            sessionList(this.sessionListForm).then(res=>{
                console.log()
                res.data.forEach(item=>{
                    console.log(item)
                    if(item.status == 0){
                        item.status = CompareTime(item.starttime) == true?1:0
                    }
                })
                this.sessionListData = res.data
            })
        },
        // 报名
        ManualRegistrationSubmit(){
            // 一个人报名
            if(this.CompetitionObj.matchGame.signNum == 1){
                if(this.ManualRegistrationForm.phoneFlag == false){
                    this.$message.error('请校验手机号')
                }else{
                    let data = [
                        {
                            nickname:this.ManualRegistrationForm.nickname,
                            phone:this.ManualRegistrationForm.phone,
                            type:this.ManualRegistrationForm.usersType
                        },
                    ]
                    matchuserAdd({
                        matchid:this.CompetitionObj.id,
                        type:this.CompetitionObj.matchGame.signNum,
                        users:data
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('报名成功')
                            this.getApplicationList()
                            this.ManualRegistrationFlag = false
                        }
                    })
                }
            }else if(this.CompetitionObj.matchGame.signNum == 2){
                if(this.ManualRegistrationForm.phoneFlag == false){
                    this.$message.error('请校验手机号')
                }else if(this.ManualRegistrationForm.phoneFlag2 == false){
                    this.$message.error('请校验队友手机号')
                }else{
                    let data = [
                        {
                            nickname:this.ManualRegistrationForm.nickname,
                            phone:this.ManualRegistrationForm.phone,
                            type:this.ManualRegistrationForm.usersType
                        },
                        {
                            nickname:this.ManualRegistrationForm.nickname2,
                            phone:this.ManualRegistrationForm.phone2,
                            type:this.ManualRegistrationForm.usersType
                        },
                    ]
                    matchuserAdd({
                        matchid:this.CompetitionObj.id,
                        type:this.CompetitionObj.matchGame.signNum,
                        users:data
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('报名成功')
                            this.getApplicationList()
                            this.ManualRegistrationFlag = false
                        }
                    })
                }
            }
        },
        // 取消报名
        CancelRegistration(row){
            this.$confirm('确认取消报名?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                matchuserDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getApplicationList()
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        // 校验用户
        getUserDetails(type){
            const regex = /^1[3456789]\d{9}$/;
            let phone = type == 1?this.ManualRegistrationForm.phone:this.ManualRegistrationForm.phone2
            if(!regex.test(phone)){
                this.$message.error('手机号格式错误')
            }else {
                usersWithPhone({
                    phone:phone
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('校验通过')
                        if(type == 1){
                            this.ManualRegistrationForm.nickname = res.data.nickname
                            this.ManualRegistrationForm.phoneFlag = true
                        }else {
                            this.ManualRegistrationForm.nickname2 = res.data.nickname
                            this.ManualRegistrationForm.phoneFlag2 = true
                        }
                    }
                })
            }
        },
        ManualRegistrationClick(){
            this.ManualRegistrationFlag = true
            this.ManualRegistrationForm = {
                nickname:'',
                phone:'',
                phoneFlag:false,
                nickname2:'',
                phone2:'',
                phoneFlag2:false,
                usersType:0
            }
        },
        // 查询报名
        applicationCallFather(e){
            console.log()
            this.applicationPage.currentPage = e.currentPage
            this.applicationPage.pageSize = e.pageSize
            this.getApplicationList()
        },
        // 获取报名列表
        getApplicationList(){
            matchuserList({
                page:this.applicationPage.currentPage,
                pageSize:this.applicationPage.pageSize,
                matchid:this.CompetitionObj.id,
                nickname:this.applicationForm.nickname,
                status:this.applicationForm.status,
                phone:this.applicationForm.phone,
            }).then(res=>{
                    this.applicationData = res.data.dataList
                    this.applicationPage.total = res.data.total
            })
            // currentPage: 1,
            //     pageSize: 10,
        },
        applicationClick(row){
            this.CompetitionObj = row
            this.applicationFlag = true
            this.getApplicationList()
        },
        // 删除时间段
        delTimeClick(row){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                timeDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.siteListClick()
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 选择时间
        noticetimeChange(e){
            this.matchwayDetailForm.endtime = this.addHoursToTime(e , this.matchwayDetailForm.timeLong + this.matchwayDetailForm.beforetime )
        },
        // 添加时间段提交
        addTimeSubmit(){
            if(this.matchwayDetailForm.endtime == ''){
                this.$message.error('请选择时间')
            }else {
                timeAdd({
                    matchId:this.matchwayDetailForm.matchId,
                    stageId:this.matchwayDetailForm.stageId,
                    noticetime:this.matchwayDetailForm.noticetime,
                    endtime:this.matchwayDetailForm.endtime,
                    weekday:this.matchwayDetailForm.type
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('添加成功')
                        this.addTimeFlag = false
                        this.siteListClick()
                    }
                })
            }
        },
        addHoursToTime(timeStr, addMinutes) {
            let time = timeStr.split(':')
            let HH = Math.floor(Number(time[0]) + ((Number(time[1]) + Number(addMinutes))/60))
            let mm = (Number(time[1]) + Number(addMinutes))%60
            let HH_num = HH >= 24?HH%24:HH
            return `${HH_num < 10?'0'+HH_num:HH_num}:${mm < 10?'0'+mm:mm}:${time[2]}`
        },
        // 添加时段
        addTimeClick(type){
            matchwayDetail(this.stageId).then(res=>{
                if(res.data != null){
                    res.data.noticetime = ''
                    res.data.endtime = ''
                    res.data.type = type
                    this.matchwayDetailForm = res.data
                    this.addTimeFlag = true
                }else {
                    this.$message.error('请先设置比赛方式')
                }
            })
        },
        editM2achineClick(row){
            console.log(row)
            this.editM2achineReplaceForm = {
                id:row.id,
                name:row.name,
                orderCode:row.orderCode
            }
            this.editM2achineReplaceFlag = true
        },
        // 修改设备信息
        editM2achineReplaceSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    m2achineUpdate(this.editM2achineReplaceForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('修改成功')
                            this.deviceEditClick(this.siteDataForm)
                            this.editM2achineReplaceFlag = false
                        }
                    })
                    console.log(this.deviceForm)
                    console.log(this.siteDataForm)
                } else {
                    return false
                }
            })
        },
        // 替换设备点击
        m2achineReplaceClick(row){
            this.m2achineReplaceFlag = true
            this.m2achineReplaceId = row.id
        },
        // 替换设备提交
        m2achineReplaceSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    m2achineReplace({
                        id:this.m2achineReplaceId,
                        machineId:this.m2achineReplaceForm.machineId,
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('替换成功')
                            this.deviceEditClick(this.siteDataForm)
                            this.m2achineReplaceForm.machineId = ''
                            this.m2achineReplaceFlag = false
                        }
                    })
                    console.log(this.deviceForm)
                    console.log(this.siteDataForm)
                } else {
                    return false
                }
            })
        },
        // 删除场地
        m2achineDelClick(row){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                m2achineDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.deviceEditClick(this.siteDataForm)
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 添加场地设备
        deviceFormSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    m2achineAdd({
                        name:this.deviceForm.name,
                        machineId:this.deviceForm.machineId,
                        stageId:this.siteDataForm.stageId,
                        matchId:this.siteDataForm.matchId,
                        siteId:this.siteDataForm.id,
                        orderCode:this.deviceForm.orderCode
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('添加成功')
                            this.deviceEditClick(this.siteDataForm)
                        }
                    })
                    console.log(this.deviceForm)
                    console.log(this.siteDataForm)
                } else {
                    return false
                }
            })
        },
        deviceEditClick(row){
            this.siteDataForm = row
            this.deviceForm = {
                name:'',
                machineId:'',
                orderCode:''
            }
            m2achineList({id:row.id}).then(res=>{
                this.m2achineDataList = res.data
                this.deviceFlag = true
                
            })
        },
        //机器列表 
        getLoadMachineList(){
            loadMachineList({page:1,pageSize:500}).then(res=>{
                this.MachineList = res.data
            })
        },
        // 删除场地
        siteDelClick(row){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                siteDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.siteListClick()
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 编辑场地
        editSiteClick(row){
            let data = JSON.parse(JSON.stringify(row))
            let imgList = data.pics.split(';')
            let imgData = []
            imgList.forEach(item=>{
                imgData.push({url:item})
            })
            data.pics = imgData
            this.addSiteForm = data
            this.addSiteFlag = true
        },
        // 添加场地提交
        addSiteSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.addSiteForm)
                    let data  = JSON.parse(JSON.stringify(this.addSiteForm))
                    let imgList = []
                    data.pics.forEach((item)=>{
                        imgList.push(item.url)
                    })
                    data.pics = imgList.join(";")
                    siteSave(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success("操作成功")
                            this.addSiteFlag = false
                            this.siteListClick()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 添加场地
        addSizeClick(){
            this.addSiteForm = {
                pics:[],
                name:'',
                siteAddr:'',
                stageId:this.stageId,
                matchId:this.competitionId,
            }
            this.addSiteFlag = true
        },
        // 点击参赛设备
        siteListClick(){
            this.SiteManagementFlag = true
            siteList(this.stageId).then(res=>{
                this.SiteManagementData = res.data
            })
            timeList(this.stageId).then(res=>{
                this.siteTimeList = res.data
            })
        },
        // 编辑奖励点击
        editRewards(row){
            let data = JSON.parse(JSON.stringify(row))
            data.prizePics = [{url:data.prizePics}]
            this.editRewardsFlag = true
            this.AddRewardForm = data
            this.AddRewardFlag = true
        },
        // 删除奖励
        RankingDel(row){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rewardDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.CompetitionRewardsClick()
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 提交编辑奖励
        AddRewardSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.AddRewardForm)
                    let data = this.AddRewardForm
                    if(data.type == 1 && data.lowRank > data.upRank){
                        this.$message.error('后者名次不能小于前者名次')
                    }else {
                        data.prizePics = data.prizePics[0].url
                        rewardSave(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else{
                                this.$message.success('操作成功')
                                this.CompetitionRewardsClick()
                                this.AddRewardFlag = false
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        // 点击创建奖励
        addRewardClick(type){
            if(type == 1){
                if(this.RankingRewardsData.length == 0){
                    this.AddRewardForm = {
                        lowRank:1,
                        prizePics:[],
                        prizeName:'',
                        upRank:'',
                        type:1,
                        stageId:this.stageId,
                        matchId:this.competitionId
                    }
                }else {
                    let num = this.RankingRewardsData[this.RankingRewardsData.length - 1].upRank
                    this.AddRewardForm = {
                        lowRank:num + 1,
                        prizePics:[],
                        prizeName:'',
                        upRank:'',
                        type:1,
                        stageId:this.stageId,
                        matchId:this.competitionId
                    }
                }
            }else if(type == 0){
                if(this.PromotionRewardData.length != 0){
                    this.$message.error('该奖励已添加') 
                    return
                } 
                this.AddRewardForm = {
                        lowRank:"",
                        prizePics:[],
                        prizeName:'',
                        upRank:'',
                        type:0,
                        stageId:this.stageId,
                        matchId:this.competitionId
                    }
            }
            this.AddRewardFlag = true
            this.editRewardsFlag = false
        },
        // 获取奖励列表
        CompetitionRewardsClick(){
            rewardList(this.stageId).then(res=>{
                let RewardsData1 = []
                let RewardsData2 = []
                res.data.forEach(item=>{
                    console.log(item)
                    if(item.type == 1){
                        RewardsData1.push(item)
                    }else {
                        RewardsData2.push(item)
                    }
                })
                this.RankingRewardsData = RewardsData1
                this.PromotionRewardData = RewardsData2
                this.CompetitionRewardsFlag = true
            })
        },
        // 选择晋级方式
        typeRadio(e){
            console.log(e)
            if(e == 2){
                this.editBePromotedForm.isProportion = false
            }
        },
        // 编辑晋级方式提交
        editBePromotedSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    let data = this.editBePromotedForm
                    // type:1,
                    // isProportion:true
                    // promotedNum
                    console.log(data.promotedNum%2 != 0)
                    if(data.type == 1 && data.isProportion == true && data.promotedNum > 100){
                        this.$message.error('晋级比例不能超过100%')
                    }
                    // else if(data.type == 1 && data.isProportion == false && data.promotedNum%2 != 0 && this.CompetitionObj.matchGame.signNum == 2 ){
                    //     this.$message.error('晋级人数不能是单数')
                    // }
                    else {
                        if(data.type == 2 && data.isProportion == false  && this.CompetitionObj.matchGame.signNum == 2){
                            data.promotedNum = 1
                        }
                        // if(data.isProportion == false){
                        //     data.promotedNum = data.promotedNum*2
                        // }
                        promotionSave(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.editBePromotedFlag = false
                                this.$message.success('编辑成功')
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        // 编辑晋级方式点击
        editBePromotedClick(){
            promotionDetail(this.stageId).then(res=>{
                if(res.data == null){
                    this.editBePromotedForm = {
                        stageId:this.stageId,
                        matchId:this.competitionId,
                        type:1,
                        isProportion:true,
                        promotedNum:'',
                    }
                }else {
                    this.editBePromotedForm = res.data
                }
                this.editBePromotedFlag = true
            })
        },
        // 编辑匹配方式
        editMatchingMethodSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.editCompetitionMethodForm)
                    let data = this.editMatchingMethodForm
                    data.ruleName = data.ruleId == 1?'随机匹配':'瑞士移位'
                    data.personNum = this.pnum * data.personMulNum
                    mateAdd(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.editMatchingMethodFlag = false
                            this.$message.success('编辑成功')
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 编辑匹配方式点击
        editMatchingMethodClick(){
            ruleDetail(this.stageId).then(res=>{
                if(res.data != null){
                    this.pnum = res.data.pnum
                    mateDetail(this.stageId).then(mateRes=>{
                        this.editMatchingMethodFlag = true
                        if(mateRes.data == null){
                            this.editMatchingMethodForm = {
                                stageId:this.stageId,
                                matchId:this.competitionId,
                                type:1,
                                ruleId:1,
                                ruleName:'',
                                personMulNum:"",
                                personNum:''
                            }
                        }else {
                            this.editMatchingMethodForm = mateRes.data
                        }
                    })
                }else {
                   this.$message.error('请先编辑比赛规则') 
                }  
            })
            
            console.log(this.CompetitionObj)
            console.log(this.stageDataForm)
        },
        // 编辑比赛规则
        GameRulesSubmitFun(e){
            console.log(e)
            ruleAdd(e).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else{
                    this.GameRulesFlag = false
                    this.$message.success('操作成功')
                }
            })
        },
        GameRulesCancel(){
            this.GameRulesFlag = false
        },
        GameRulesSubmit(){
            console.log(this.$refs.GameRulesRef.obj)
        },
        GameRulesClick(){
            this.GameRulesFlag = true
        },
        // 编辑比赛方式
        editCompetitionMethodSubmitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.editCompetitionMethodForm)
                    matchwaySave(this.editCompetitionMethodForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.editCompetitionMethodFlag = false
                            this.$message.success('编辑成功')
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 编辑阶段点击逻辑
        editStageClick(row){
            console.log(row)
            if(row.ordernum == 1){
                this.addStageFlag = true
                this.addStageType = 1
                this.addStageForm = row
            }else{
                this.addStageFlag = true
                this.addStageType = 2
                this.addStageForm = row
            }
        },
        // 删除阶段
        stageDel(row){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                stageDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.stageClick(this.CompetitionObj)
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        // 创建-编辑阶段提交
        StageSubmitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    console.log(this.addStageForm)
                    if(this.addStageForm.id == undefined){
                        let data = {}
                        if(this.addStageType == 1){
                            let time1 = new Date(formatTime(this.CompetitionObj.starttime)).getTime()
                            let time2 = new Date(formatTime(this.addStageForm.starttime)).getTime()
                            if(time1 > time2){
                                this.$message.error('阶段开始时间不能在比赛开始时间之前')
                                return
                            }
                            data = {
                                name:this.addStageForm.name,
                                starttime:this.addStageForm.starttime,
                                matchId:this.competitionId
                            }
                        }else {
                            data = {
                                name:this.addStageForm.name,
                                days:this.addStageForm.days,
                                matchId:this.competitionId
                            }
                        }
                        stageAdd(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('创建成功')
                                this.addStageFlag = false
                                this.stageClick(this.CompetitionObj)
                                this.getMatchList()
                            }
                        })
                    }else {
                        if(this.addStageType == 1){
                            let time1 = new Date(formatTime(this.CompetitionObj.starttime)).getTime()
                            let time2 = new Date(formatTime(this.addStageForm.starttime)).getTime()
                            if(time1 > time2){
                                this.$message.error('阶段开始时间不能在比赛开始时间之前')
                                return
                            }
                        }
                        stageUpdate(this.addStageForm).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('创建成功')
                                this.addStageFlag = false
                                this.stageClick(this.CompetitionObj)
                                this.getMatchList()
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        // 发布比赛
        matchPublishClick(row){
            this.$confirm('确认发布?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                matchPublish(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getMatchList()
                    }else{
                        this.$confirm(res.message, '提示', {
                            confirmButtonText: '确定',
                            // cancelButtonText: '取消',
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        // 删除比赛
        delMatch(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                matchDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getMatchList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 获取比赛列表
        getMatchList(){
            matchList({
                pageSize:this.pageparm.pageSize,
                currentPage:this.pageparm.currentPage
            }).then(res=>{
                this.pageparm.total = res.data.total
                this.matchDataList = res.data.dataList
            })
        },
        callFather(e){
            console.log(e)
            this.pageparm.currentPage = e.currentPage
            this.pageparm.pageSize = e.pageSize
            this.getMatchList()
        },
        // 选择游戏name
        gamesSlChange(e){
            this.gamesList.forEach(item=>{
                if(item.id == e){
                    this.addCompetitionForm.gameName = item.gameName
                }
            })
        },
        // 日期选择
        daterangeChange(e){
            if(e != null){
                this.addCompetitionForm.starttime = e[0]
                this.addCompetitionForm.endtime = e[1]
            }else {
                this.addCompetitionForm.starttime = ''
                this.addCompetitionForm.endtime = ''
            }
        },
        // 创建比赛
        submitForm(form){
            // console.log(this.city)
            console.log(this.addCompetitionForm)
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.addCompetitionForm.id == undefined){
                        // let time1 = new Date(formatTime(this.addCompetitionForm.starttime)).getTime()
                        // let time2 = new Date().getTime()
                        // if(time1 < time2){
                        //     this.$message.error('比赛报名开始时间不能在当前时间之前')
                        //     return
                        // }
                        let data = {
                            name:this.addCompetitionForm.name,
                            content:this.addCompetitionForm.content.replace(/img/g,`img style="width:100%"`),
                            machineShow:this.addCompetitionForm.machineShow,
                            limitPer:this.addCompetitionForm.limitPer,
                            limitNum:Number(this.addCompetitionForm.limitNum),
                            starttime:this.addCompetitionForm.starttime,
                            endtime:this.addCompetitionForm.endtime,
                            shareTitle:this.addCompetitionForm.shareTitle,
                            shareContent:this.addCompetitionForm.shareContent,
                            province:this.addCompetitionForm.addr[0],
                            city:this.addCompetitionForm.addr[1] == undefined?'':this.addCompetitionForm.addr[1],
                            gameId:this.addCompetitionForm.gameId,
                            gameName:this.addCompetitionForm.gameName,
                            machinePics:JSON.stringify(this.addCompetitionForm.machinePics),
                            screenPics:JSON.stringify(this.addCompetitionForm.screenPics),
                            programPics:JSON.stringify(this.addCompetitionForm.programPics),
                            sharePic:JSON.stringify(this.addCompetitionForm.sharePic),
                            titleImg:JSON.stringify(this.addCompetitionForm.titleImg),
                        }
                        // this.imgJsonFun()
                        console.log(data)
                        matchAdd(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('创建成功')
                                this.addCompetitionFlag = false
                                this.getMatchList()
                            }
                        }) 
                    }else {
                        // let time1 = new Date(formatTime(this.addCompetitionForm.starttime)).getTime()
                        // let time2 = new Date().getTime()
                        // if(time1 < time2){
                        //     this.$message.error('比赛报名开始时间不能在当前时间之前')
                        //     return
                        // }
                        let data = this.CompetitionObj 
                        data.name = this.addCompetitionForm.name,
                        data.content = this.addCompetitionForm.content.replace(/img/g,`img style="width:100%"`),
                        data.machineShow = this.addCompetitionForm.machineShow,
                        data.limitPer = this.addCompetitionForm.limitPer,
                        data.limitNum = Number(this.addCompetitionForm.limitNum),
                        data.starttime = this.addCompetitionForm.starttime,
                        data.endtime = this.addCompetitionForm.endtime,
                        data.shareTitle = this.addCompetitionForm.shareTitle,
                        data.shareContent = this.addCompetitionForm.shareContent,
                        data.province = this.addCompetitionForm.addr[0],
                        data.city = this.addCompetitionForm.addr[1] == undefined?'':this.addCompetitionForm.addr[1],
                        data.gameId = this.addCompetitionForm.gameId,
                        data.gameName = this.addCompetitionForm.gameName,
                        data.machinePics = JSON.stringify(this.addCompetitionForm.machinePics),
                        data.screenPics = JSON.stringify(this.addCompetitionForm.screenPics),
                        data.programPics = JSON.stringify(this.addCompetitionForm.programPics),
                        data.sharePic = JSON.stringify(this.addCompetitionForm.sharePic),
                        data.titleImg = JSON.stringify(this.addCompetitionForm.titleImg),
                        
                        // this.imgJsonFun()
                        console.log(data)
                        matchUpdate(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('修改')
                                this.addCompetitionFlag = false
                                this.getMatchList()
                            }
                        })
                    }
                    
                } else {
                    return false
                }
            })
            
        },
        //处理图片列表
        imgJsonFun(data){
            let list = []
            data.forEach(item=>{
                list.push(item.url)
            })
            return list.join(';')
        },
        // 获取阶段详情
        editCompetitionMethodClick(){
            let data = []
            CompetitionMethodData().forEach(item=>{
                console.log(item)
                if((this.CompetitionObj.matchGame.unit&item.unit) != 0){
                    data.push(item)
                }
            })
            console.log(data)
            this.MethodData = data
            matchwayDetail(this.stageId).then(res=>{
                if(res.data == null){
                    this.$message.error('请先编辑比赛规则')
                }else {
                    if(res.data.type == null){
                        let MethodForm = res.data
                        MethodForm.type = 1
                        MethodForm.timesNum = ""
                        MethodForm.timeLong = ""
                        MethodForm.beforetime = ""
                        this.editCompetitionMethodForm = MethodForm
                        // this.editCompetitionMethodForm = {
                        //     type:1,
                        //     timesNum:"",
                        //     timeLong:"",
                        //     stageId:this.stageId,
                        //     matchId:this.competitionId,
                        //     beforetime:"",
                        //     gameUnit:res.data.gameUnit
                        // }
                        let data = CompetitionMethodNum(res.data.gameUnit)
                        this.gameUnitName = data.name
                        this.gameUnitNumS = data.numS
                    }else {
                        let data = CompetitionMethodNum(res.data.gameUnit)
                        this.gameUnitName = data.name
                        this.gameUnitNumS = data.numS
                        this.editCompetitionMethodForm = res.data
                    }
                    this.editCompetitionMethodFlag = true
                }
            })
        },
        // 编辑规则点击
        editRuleClick(row){
            this.stageDataForm = row
            this.stageId = row.id
            this.editRuleFlag = true
        },
        // 创建阶段点击
        addStageClick(){
            if(this.stageDataList.length == 0){
                this.addStageType = 1
            }else {
                this.addStageType = 2
            }

            this.addStageForm = {
                name:'',
                starttime:'',
                days:''
            }
            this.addStageFlag = true
        },
        // 比赛列表点击阶段
        stageClick(row){
            this.competitionId = row.id
            this.CompetitionObj = row
            stageList(row.id).then(res=>{
                this.stageDataList = res.data
                this.stageFlag = true
            })
            
        },
        // 富文本
        onEditorChange(e){
            this.addCompetitionForm.content = e.html
        },
        editConsumptionClick(row){
            console.log(row)
            this.CompetitionObj = row
            let addrData = [`${row.province}`]
            if(row.city != ''){
                addrData.push(row.city)
            }
            this.addCompetitionForm = {
                id:row.id,
                name:row.name,
                content:row.content,
                machineShow:row.machineShow,
                limitPer:row.limitPer,
                limitNum:row.limitNum,
                dateTime:[`${row.starttime}`,`${row.endtime}`],
                starttime:row.starttime,
                endtime:row.endtime,
                shareTitle:row.shareTitle,
                shareContent:row.shareContent,
                province:row.province,
                city:row.city,
                gameId:row.gameId,
                gameName:row.gameName,
                machinePics:JSON.parse(row.machinePics),
                screenPics:JSON.parse(row.screenPics),
                programPics:JSON.parse(row.programPics),
                sharePic:JSON.parse(row.sharePic),
                titleImg:row.titleImg == null?[]:JSON.parse(row.titleImg),
                addr:addrData
                // machinePics:[],
                // screenPics:[],
                // programPics:[],
                // sharePic:[],
            }
            console.log(this.addCompetitionForm)
            this.addCompetitionFlag = true
        },
        // 创建比赛点击
        addConsumptionClick(){
            this.addCompetitionForm = {
                name:"",
                content:"",
                machineShow:true,
                limitPer:true,
                limitNum:'',
                dateTime:[],
                starttime:"",
                endtime:"",
                shareTitle:"",
                shareContent:"",
                province:"",
                city:'',
                gameId:'',
                gameName:'',
                machinePics:[],
                screenPics:[],
                programPics:[],
                sharePic:[],
                titleImg:[],
                addr:''
            }
            this.addCompetitionFlag = true
        },
        HandleChange1(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addCompetitionForm.machinePics.push({
                    url:res.data.data
                })
            })
        },
        HandleChange2(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addCompetitionForm.programPics.push({
                    url:res.data.data
                })
            })
        },
        HandleChange3(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addCompetitionForm.screenPics.push({
                    url:res.data.data
                })
            })
        },
        HandleChange4(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addCompetitionForm.sharePic.push({
                    url:res.data.data
                })
            })
        },
        HandleChange5(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.AddRewardForm.prizePics.push({
                    url:res.data.data
                })
            })
        },
        HandleChange6(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addSiteForm.pics.push({
                    url:res.data.data
                })
            })
        },

        CompetitionTitle(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.addCompetitionForm.titleImg.push({
                    url:res.data.data
                })
            })
        },

        CompetitionTitleRemove(e){
            console.log(e.url)
            let data = []
            for(let item of this.addCompetitionForm.titleImg){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addCompetitionForm.titleImg = data
        },

        HandleRemove1(e){
            console.log(e.url)
            let data = []
            for(let item of this.addCompetitionForm.machinePics){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addCompetitionForm.machinePics = data
        },
        HandleRemove2(e){
            console.log(e.url)
            let data = []
            for(let item of this.addCompetitionForm.programPics){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addCompetitionForm.programPics = data
        },
        HandleRemove3(e){
            console.log(e.url)
            let data = []
            for(let item of this.addCompetitionForm.screenPics){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addCompetitionForm.screenPics = data
        },
        HandleRemove4(e){
            console.log(e.url)
            let data = []
            for(let item of this.addCompetitionForm.sharePic){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addCompetitionForm.sharePic = data
        },
        HandleRemove5(e){
            console.log(e.url)
            let data = []
            for(let item of this.AddRewardForm.prizePics){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.AddRewardForm.prizePics = data
        },
        HandleRemove6(e){
            console.log(e.url)
            let data = []
            for(let item of this.addSiteForm.pics){
                if(e.url != item.url){
                    data.push(item)
                }
            }
            this.addSiteForm.pics = data
        },
        async onUploadHandler(file) {
            let formData = new FormData()
            formData.append('file' ,file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                // 获取光标所在位置
                let quill = this.$refs.myQuillEditor.quill
                let length = quill.getSelection().index
                // 插入图片
                quill.insertEmbed(length, 'image', res.data.data)
                // 调整光标到最后
                quill.setSelection(length + 1)
            })
        },
        // 获取游戏列表
        matchGamesList(){
            matchGames().then(res=>{
                this.gamesList = res.data
            })
        }
    }
}
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
    
}
</style>


// WEBPACK FOOTER //
// src/views/competition/competitionList.vue